<template>
    <section :class="css.container">
        <div :class="css.header">
            <div class="container" :class="css.header_body">
                <h2 :class="css.title" class="font-variable color-1 font-bold">{{ $t("TranscriptsProteins") }}</h2>
                <UiTooltip :zIndex="68" :width="600" direction="bottom" align="start" :classExtraName="css_normalize.tip">
                    <img src="https://rdgta.cdn.cyagen.com/rddc/pictures/95736da3-4f56-4a9d-b2d5-3536397ad088.webp" alt="" />
                    <template #content>
                        <div :class="css_normalize.context">{{ $t("TranscriptsProteinsDescript3") }}</div>
                        <div :class="css_normalize.indexs">
                            <div :class="css_normalize.index">{{ $t("TranscriptsProteinsDescript4") }}</div>
                            <div :class="css_normalize.index">{{ $t("TranscriptsProteinsDescript5") }}</div>
                        </div>
                        <div :class="css_normalize.context">{{ $t("TranscriptsProteinsDescript6") }}</div>
                    </template>
                </UiTooltip>
            </div>
        </div>

        <div :class="css.error" class="container text-hint" v-if="!exist">{{ $t("TranscriptsProteinsDescript2") }}</div>
        <div :class="css.body" class="container" ref="container" v-loading="loading" v-else>
            <!-- * 选择器 -->
            <div :class="css.controls">
                <div>{{ descript }}</div>
                <default-selector v-model="mode" :class="css.selector" :candidates="options.modes" @change="methods.mode" />
            </div>

            <!-- * 转录本图 -->
            <div :class="css.canvas" v-show="mode == 'visual'">
                <visual-list-sequence ref="visualList" @click="methods.next" />
            </div>

            <!-- * 表格 -->
            <div :class="css.table" v-show="mode == 'table'">
                <ui-table2 :data="result" :error="$t('NoDataAvailable')" :option="options.view" :height="600" @sort="methods.sort">
                    <template #id_mrna="{ data }">
                        <ProjectRoute
                            :class="css.mrna"
                            :to="{ name: 'BioSequenceResult', query: { id: data.id_mrna, mode: 'cDNA' }, params: { id: $route.params.id } }">
                            <span :class="css_normalize.assets">{{ data.id_mrna }}</span>
                            <span :class="css.mrna_label" v-if="data.selected || data.is_clinical_selected">
                                {{ (data.selected && "MANE") || (data.is_clinical_selected && "MANE Plus") }}
                            </span>
                        </ProjectRoute>
                    </template>
                </ui-table2>
            </div>
            <div style="margin-top: 20px">* {{ $t("Layout.ModuleDataSource", { name: "NCBI" }) }}</div>
        </div>
    </section>
</template>

<script lang="ts" setup>
//* 组件库
import { UiTable2, UiTooltip } from "various-ui";
//* 公共组件
import { DefaultSelector } from "@/components/controls";
import { VisualListSequence } from "@/components/models";
//* 组件属性
import { useComposable } from "./src/composable";
//* 样式
import css_normalize from "@/assets/style/src/index.module.less";
import css from "./style/index.module.less";

//* 组合函数
const { refs, nodes, options, methods, computeds } = useComposable();
const { mode, exist, loading, descript } = refs;
const { visualList, container } = nodes;
const { render, hidden } = methods;
const { result } = computeds;

//* 组件属性导出
defineExpose({ render, hidden });
</script>
